var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4078 23.5083L5.61455 23.5205C2.80004 23.523 0.495335 21.2228 0.492136 18.4083L0.479983 5.61504C0.477424 2.80053 2.77765 0.495823 5.59216 0.492624L18.3854 0.480471C21.1999 0.477912 23.5046 2.77814 23.5078 5.59265L23.52 18.3859C23.5232 21.201 21.2223 23.5058 18.4078 23.5083Z",
    fill: "url(#paint0_radial_20749_150386)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4078 23.5083L5.61455 23.5205C2.80004 23.523 0.495335 21.2228 0.492136 18.4083L0.479983 5.61504C0.477424 2.80053 2.77765 0.495823 5.59216 0.492625L18.3854 0.480471C21.1999 0.477912 23.5046 2.77814 23.5078 5.59265L23.52 18.3859C23.5232 21.2011 21.2223 23.5058 18.4078 23.5083Z",
    fill: "url(#paint1_radial_20749_150386)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 16.4787C9.53213 16.4787 7.52295 14.4702 7.52295 12.0011C7.52295 9.53198 9.53213 7.52344 12.0006 7.52344C14.469 7.52344 16.4782 9.53198 16.4782 12.0011C16.4782 14.4702 14.469 16.4787 12.0006 16.4787ZM12.0006 8.80276C10.237 8.80276 8.80227 10.2375 8.80227 12.0011C8.80227 13.7646 10.237 15.1994 12.0006 15.1994C13.7641 15.1994 15.1989 13.7646 15.1989 12.0011C15.1989 10.2375 13.7641 8.80276 12.0006 8.80276Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7979 8.16117C17.3278 8.16117 17.7574 7.73159 17.7574 7.20168C17.7574 6.67177 17.3278 6.24219 16.7979 6.24219C16.268 6.24219 15.8384 6.67177 15.8384 7.20168C15.8384 7.73159 16.268 8.16117 16.7979 8.16117Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8382 20.3187H8.16221C5.69375 20.3187 3.68457 18.3102 3.68457 15.8411V8.16514C3.68457 5.69604 5.69375 3.6875 8.16221 3.6875H15.8382C18.3066 3.6875 20.3158 5.69604 20.3158 8.16514V15.8411C20.3158 18.3102 18.3066 20.3187 15.8382 20.3187ZM8.16221 4.96682C6.39866 4.96682 4.96389 6.40159 4.96389 8.16514V15.8411C4.96389 17.6046 6.39866 19.0394 8.16221 19.0394H15.8382C17.6017 19.0394 19.0365 17.6046 19.0365 15.8411V8.16514C19.0365 6.40159 17.6017 4.96682 15.8382 4.96682H8.16221Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_20749_150386",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.04506 23.5371) scale(28.7202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FF543F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#FC5245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#E64771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#D53E91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761,
    stopColor: "#CC39A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_20749_150386",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.18747 0.192816) scale(19.0703 12.7065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4168C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#4168C9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.7109b293a1a4fd07e19fe472bc6c4747.svg";
export { ForwardRef as ReactComponent };